import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";

export const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: "#F8F8F8",
    height: "100%",
    position: "relative",
  },
  header: {
    width: "100%",
    height: "80px",
    padding: "9px 0px",
    backgroundColor: "#FFF",

    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.05)",
    [theme.breakpoints.down(769)]: {
      height: "190px", //
    },
  },
  wrapperInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.up(769)]: {
      justifyContent: "space-around",
    },
  },
  divRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: '20px',
    [theme.breakpoints.down(470)]: {
      gap: '0px',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down(860)]: {
      justifyContent: 'space-between',
    },
  },

  labelAndInput: {
    display: "flex",
    flexDirection: "column",
  },

  containerSteps: {
    width: "70%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    [theme.breakpoints.down(769)]: {
      display: "none", //
    },
  },
  containerCircle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "15px",
    [theme.breakpoints.down(1001)]: {
      gap: "10px",
    },
  },
  circle: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
  },
  circleOutlined: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: `2px solid ${theme.palette.primary.main}`,
  },
  circleTextOutlined: {
    "&.MuiTypography-root": {
      color: theme.palette.primary.main,
      fontSize: 16,
      fontWeight: 700,
    },
  },
  circleText: {
    "&.MuiTypography-root": {
      color: "#FFF",
      fontSize: 16,
      fontWeight: 700,
    },
  },
  textStep: {
    "&.MuiTypography-root": {
      color: "#333",
      fontSize: 18,
      fontWeight: 600,
      [theme.breakpoints.down(1001)]: {
        fontSize: 14, //
      },
    },
  },
  containerColumns: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up(769)]: {
      flexDirection: "row",
    },
  },
  logo: {
    width: "100px",
    height: "auto",
    maxHeight: "70px",
  },
  retangleOrder: {
    height: "auto",
    borderRadius: "20px",
    background: "#F8F8F8",
    padding: "10px 20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    [theme.breakpoints.up(769)]: {
      display: "none", //
    },
  },
  containerCardsDependents: {
    margin: "40px 0px",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-around",
    gap: "80px",
    [theme.breakpoints.down(1115)]: {
      display: "none", //
    },
  },
  containerCardsDependentsMobile: {
    margin: "40px 0px",
    width: "100%",
    [theme.breakpoints.up(1115)]: {
      display: "none", //
    },
  },
  containerEnvinroment: {
    [theme.breakpoints.up(769)]: {
      display: "none", //
    },
  },
  textOrder: {
    "&.MuiTypography-root": {
      color: theme.palette.text.primary,
      fontSize: 12,
      fontWeight: 700,
    },
  },
  textSecurity: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "5px",
    "&.MuiTypography-root": {
      marginRight: "30px",
      color: theme.palette.text.secondary,
      fontSize: 11,
      fontWeight: "600",
      textAlign: "end",
    },
  },
  wrapperStep: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up(769)]: {
      display: "none", //
    },
  },
  title: {
    "&.MuiTypography-root": {
      color: theme.palette.primary.dark,
      fontSize: 20,
      fontWeight: 600,
      margin: "25px 0px 0px 20px",
      [theme.breakpoints.up(769)]: {
        margin: "25px 0px 0px 60px",
      },
    },
  },
  box: {
    margin: "10px",
    backgroundColor: "#FFF",
    boxShadow: " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    padding: "20px 20px",
    [theme.breakpoints.up(769)]: {
      width: "60%",
      margin: "10px 20px 10px 60px ",
    },
  },
  boxTitle: {
    "&.MuiTypography-root": {
      color: theme.palette.text.primary,
      fontSize: 18,
      fontWeight: 500,
    },
  },
  separator: {
    width: "100%",
    border: "1px dashed #CCC",
    marginTop: "20px",
    marginBottom: "20px",
  },
  label: {
    color: theme.palette.text.primary,
    fontSize: 14,
  },
  planOptions: {
    marginTop: "20px",
  },
  button: {
    width: "100%",
    height: "60px",
    [theme.breakpoints.up(769)]: {
      width: "100%",
      height: "auto",
    },
  },
  containerButton: {
    position: "fixed",
    bottom: "0px",
    left: "0px",
    right: "0px",
    backgroundColor: "#FFF",
    padding: "10px 20px",
    boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.05)",
    zIndex: 1000,
    [theme.breakpoints.up(769)]: {
      position: "static",
      backgroundColor: "transparent",
      padding: "0px",
      boxShadow: "none",
      zIndex: "auto",
    },
  },
  containerAccordions: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    borderRadius: "10px",
  },

  containerCards: {
    display: "flex",
    justifyContent: "flex-end",
  },
  imgCards: {
    width: "110px",
    height: "30px",
  },
  containerCheckbox: {
    margin: "0px -6px",
  },
  containerCardDrSaude: {
    margin: "10px 5px",
  },
  containerHours: {
    display: "flex",
    margin: "10px 0px",
  }
}));
